module.exports = __webpack_public_path__ + "img/Strapi.25a1a066.png";